import { render, staticRenderFns } from "./ShippingAdmin.vue?vue&type=template&id=04c33587&"
import script from "./ShippingAdmin.vue?vue&type=script&lang=js&"
export * from "./ShippingAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports